/**
 * Automy.Core.Enums.Reporting.Identity.ReportType
 * JSON `type` on Report (integer 1–4). Tokens are for docs / OData names only.
 */
export default Object.freeze({
  Administration: 1, // administration
  Process: 2, // process
  Request: 3, // request
  Generic: 4, // generic
});
